import { useHeaderItems } from "@/constants/header-items";
import { FC, Fragment } from "react";
import { useLocation } from "react-router-dom";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import { PageBreadcrumbProps } from "./page-breadcrumb.types";

export const PageBreadcrumb: FC<PageBreadcrumbProps> = ({
  children,
  title,
}) => {
  const location = useLocation();

  const paths = location.pathname.split("/").filter((path) => {
    return path !== "";
  });

  const headerItems = useHeaderItems();

  const breadcrumbItem = headerItems.find((item) => {
    return item.breadcrumbName === paths[0];
  });

  return (
    <div
      className={`mx-auto flex px-2 sm:px-6 lg:px-6 my-4 mb-1 ${title ? "items-end" : "items-center"} w-full`}
    >
      <div className="flex gap-2 flex-col">
        {title && <h3 className="text-xl font-bold">{title}</h3>}
        <Breadcrumb>
          <BreadcrumbList>
            {breadcrumbItem && (
              <Fragment key={breadcrumbItem.breadcrumbName}>
                {breadcrumbItem.submenu.length === 0 &&
                breadcrumbItem.breadcrumbName === paths[0] ? (
                  <>
                    <BreadcrumbItem>
                      <BreadcrumbLink>{breadcrumbItem?.title}</BreadcrumbLink>
                    </BreadcrumbItem>
                    <BreadcrumbSeparator />
                  </>
                ) : (
                  <>
                    {breadcrumbItem.submenu.map((subitem, subindex) => (
                      <Fragment key={subindex}>
                        {subitem.breadcrumbName === paths[1] && (
                          <>
                            <BreadcrumbItem>
                              <BreadcrumbLink>
                                {breadcrumbItem.title}
                              </BreadcrumbLink>
                            </BreadcrumbItem>
                            <BreadcrumbSeparator />
                            <BreadcrumbItem>
                              <BreadcrumbPage>{subitem.title}</BreadcrumbPage>
                            </BreadcrumbItem>
                          </>
                        )}
                      </Fragment>
                    ))}
                  </>
                )}
              </Fragment>
            )}
          </BreadcrumbList>
        </Breadcrumb>
      </div>
      {children}
    </div>
  );
};
